/**
 * Modal de Confirmación para Eliminar Campo Personalizado.
 *
 * Este componente muestra un diálogo de confirmación para eliminar un campo
 * personalizado del formulario de registro de eventos. Permite al usuario
 * confirmar o cancelar la acción de eliminación.
 *
 * @author Eulicer Zapata <eulicer.zapata@iudigital.edu.co>
 * @date [Fecha de creación: 2025-11-12]
 * @updated [Fecha de última modificación: 2025-11-12]
 * @updatedBy Eulicer Zapata <eulicer.zapata@iudigital.edu.co>
 */

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import MDButton from "components/MDButton";

/**
 * Componente de diálogo de confirmación para eliminar campos personalizados.
 *
 * Muestra un modal con el nombre del campo a eliminar y opciones para
 * confirmar o cancelar la operación.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {boolean} props.openDelete - Controla la visibilidad del diálogo.
 * @param {Function} props.closeDelete - Función para cerrar el diálogo sin eliminar.
 * @param {Object} props.infoDelete - Información del campo a eliminar.
 * @param {string} props.infoDelete.label - Etiqueta/nombre del campo a eliminar.
 * @param {Function} props.submitDelete - Función que ejecuta la eliminación del campo.
 * @returns {JSX.Element} Modal de confirmación de eliminación.
 */
export function FieldDelete({ openDelete, closeDelete, infoDelete, submitDelete }) {
  return (
    <>
      <Dialog
        open={openDelete}
        onClose={closeDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ textAlign: "center" }}
      >
        <DialogTitle id="alert-dialog-title">{"Importante"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Está seguro de eliminar el campo: {infoDelete.label}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={closeDelete}>Cancelar</MDButton>
          <MDButton color="warning" onClick={submitDelete}>
            Eliminar
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
